export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType("container");
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend(
        {
            defaults: {
                ...MODEL.prototype.defaults,
                name: "C-CONTAINER-CONDITIONAL",
                "custom-name": "C-CONTAINER-CONDITIONAL",
                attributes: {
                    "data-lg-type": "C-CONTAINER-CONDITIONAL",
                },
                classes: [],
                traits: [
                    // {
                    //     type: "text",
                    //     name: "data-lg-conditions",
                    //     label: "Conditions",
                    //     placeholder: "Conditions", // Placeholder to show inside the input
                    // },
                    {
                        type: "conditions_editor",
                        text: "Conditions",
                        name: "data-lg-conditions",
                        full: true, // Full width button
                    },
                    {
                        type: "checkbox",
                        name: "data-lg-no-hide",
                        label: "No hide",
                    },
                ].concat(MODEL.prototype.defaults.traits),
            },
            onRender() {},
        },
        {
            isComponent(el) {
                if (
                    el &&
                    el.getAttribute &&
                    el.getAttribute("data-lg-type") == "C-CONTAINER-CONDITIONAL"
                )
                    return { type: "C-CONTAINER-CONDITIONAL" };
            },
        }
    );
    var view = VIEW.extend({});

    DOMC.addType("C-CONTAINER-CONDITIONAL", {
        model: model,
        view: view,
    });

    BM.add("B-CONTAINER-CONDITIONAL", {
        label: "CONTAINER CONDITIONAL",
        content: {
            type: "C-CONTAINER-CONDITIONAL",
        },
        category: "ADVANCE COMPONENT",
    });
};
